import React from 'react'

export default () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 18.6667V7H5.33333V18.6667H2ZM7.83333 18.6667V2H11.1667V18.6667H7.83333ZM13.6667 18.6667V12H17V18.6667H13.6667Z" fill="currentColor"/>
  </svg>
)